autoslash.createNamespace("autoslash.autoselect");
autoslash.register(autoslash.autoselect);

autoslash.autoselect.initialize = function(element) {
    "use strict";
    element.find("[data-autoslash-autoselect]").focus(function() { $(this).select(); });
}